import { render, staticRenderFns } from "./ProductImageInputs.vue?vue&type=template&id=20822c5e&"
import script from "./ProductImageInputs.vue?vue&type=script&lang=ts&"
export * from "./ProductImageInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports